import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Names from main.css that tailwind-merge cannot classify. Unregistered, it files
// the shadows as shadow colours (so `shadow-float` survives a later `shadow-none`)
// and `bg-felt-gradient` as a background colour (so it silently drops `bg-card`).
const twMerge = extendTailwindMerge({
	extend: {
		theme: { shadow: ["club", "float", "card"], "drop-shadow": ["card"] },
		classGroups: { "bg-image": [{ bg: ["felt-gradient"] }] }
	}
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
